// `decodeHtml` vivía acá y se mudó a `utils/decodeHtml.js` el 12-ago-2026: no
// tiene nada que ver con QR y la usan cuatro pantallas más. El porqué de su
// implementación está en el header de ese archivo.

// Codifica un producto/variación en el string QR del sistema.
// Formato: "SH-VAR-{varId}" o "SH-PROD-{prodId}"
export function makeQrValue(productId, variationId) {
  if (variationId) return `SH-VAR-${variationId}`;
  return `SH-PROD-${productId}`;
}

// Parsea un string QR y devuelve { type, id } o { type: 'unit', serialCode } o null.
export function parseQrValue(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const s = raw.trim();
  const varMatch = s.match(/^SH-VAR-(\d+)$/);
  if (varMatch) return { type: 'variation', id: Number(varMatch[1]) };
  const prodMatch = s.match(/^SH-PROD-(\d+)$/);
  if (prodMatch) return { type: 'product', id: Number(prodMatch[1]) };
  // Unidad individual: SH-U-{loteNorm}-{idx}  ej: SH-U-L0003-03
  if (/^SH-U-[A-Z0-9]+-\d+$/.test(s)) return { type: 'unit', serialCode: s };
  return null;
}
